import React from 'react-x';
import propTypes from 'prop-types-x';
import classNames from 'classnames';
import { CssAnimation } from './CssAnimation.jsx';

export function Divider(props) {

  const { classes, cssAnimation, cssAnimationDelay } = props;

  return (
    <CssAnimation
    enter={{ name: 'expand-width', delay: `${cssAnimationDelay}, hidden` }}
    triggerEnter={'in-view-init'}
    disable={!cssAnimation}
    >
      <hr className={classNames({
        'c-divider': true,
        [classes]: classes
      })} />
    </CssAnimation>
  )
};

Divider.propTypes = {
  classes: propTypes.string,
  cssAnimation: propTypes.bool,
  cssAnimationDelay: propTypes.number,
};

Divider.defaultProps = {
  cssAnimation: true, 
  cssAnimationDelay: 0.5
};